// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Mt5n","inner":"Footer_inner__1M20r"};